module.exports = __webpack_public_path__ + "static/media/g-icon-search.f74aceb7.svg";